 
import React, { useState, useEffect } from "react";
import { Button, Form, Input, Upload, Space, Select, Divider, Flex } from "antd";
import { DeleteOutlined, UploadOutlined, PlusOutlined } from "@ant-design/icons";

const FlightDetailsEditor = ({ slide, updateSlide, removeSlide, triggerSave }) => {
  const [flights, setFlights] = useState(slide.flights || []);
  const [newFlight, setNewFlight] = useState({
    type: "DEPARTURE",
    time: "",
    date: "",
    airline: "",
    city: "",
    airport: "",
  });
  const [formData, setFormData] = useState(slide);

 
  useEffect(() => {
    setFlights(slide.flights || []);
    setFormData(slide);
  }, [slide]);

 
  useEffect(() => {
    updateSlide(slide.id, { ...formData, flights });
  }, [triggerSave]);

 
  const addFlight = () => {
    if (!newFlight.time || !newFlight.date || !newFlight.city) return;

    if (flights.length < 4) {
      setFlights([...flights, { ...newFlight }]);
    } else {
 
      const newSlide = {
        id: Date.now(),
        title: formData.title || "FLIGHT DETAILS",
        subtitle: formData.subtitle || "",
        flights: [{ ...newFlight }],
        bg: formData.bg || null,
      };
      updateSlide("ADD_NEW_SLIDE", newSlide);
    }

    setNewFlight({
      type: "DEPARTURE",
      time: "",
      date: "",
      airline: "",
      city: "",
      airport: "",
    });
  };

  const updateFlight = (idx, key, value) => {
    const next = [...flights];
    next[idx][key] = value;
    setFlights(next);
  };

  const removeFlightItem = (idx) => {
    setFlights(flights.filter((_, i) => i !== idx));
  };

  const handleBgUpload = (info) => {
    const file = info.file.originFileObj || info.file;
    if (file && file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => setFormData({ ...formData, bg: reader.result });
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="border rounded-lg p-3 bg-white shadow-sm">
      <Divider />
      <h1 className="font-semibold mb-4 text-lg">Edit Flight Slide</h1>
      <Form layout="vertical">
        {/* Editable Heading */}
        <Form.Item label="Heading">
          <Input
            value={formData.title || "FLIGHT DETAILS"}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          />
        </Form.Item>

        {/* Editable Tagline */}
        <Form.Item label="Tagline">
          <Input
            value={formData.subtitle || ""}
            placeholder="Your Journey Awaits"
            onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
          />
        </Form.Item>

        {/* Flights List */}
        <Form.Item label="Flights">
          {flights.map((f, idx) => (
            <div key={idx} className="border rounded p-3 mb-3 bg-gray-50">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Select
                  value={f.type}
                  options={[
                    { label: "Departure", value: "DEPARTURE" },
                    { label: "Arrival", value: "ARRIVAL" },
                  ]}
                  onChange={(val) => updateFlight(idx, "type", val)}
                />
                <Input
                  placeholder="Time"
                  value={f.time}
                  onChange={(e) => updateFlight(idx, "time", e.target.value)}
                />
                <Input
                  placeholder="Date"
                  value={f.date}
                  onChange={(e) => updateFlight(idx, "date", e.target.value)}
                />
                <Input
                  placeholder="Airline"
                  value={f.airline}
                  onChange={(e) => updateFlight(idx, "airline", e.target.value)}
                />
                <Input
                  placeholder="City"
                  value={f.city}
                  onChange={(e) => updateFlight(idx, "city", e.target.value)}
                />
                <Input
                  placeholder="Airport"
                  value={f.airport}
                  onChange={(e) => updateFlight(idx, "airport", e.target.value)}
                />
                <Button
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => removeFlightItem(idx)}
                >
                  Remove Flight
                </Button>
              </Space>
            </div>
          ))}

          {/* Add new flight */}
          <div className="border rounded p-3 bg-gray-100 mt-2">
            <Space direction="vertical" style={{ width: "100%" }}>
              <Select
                value={newFlight.type}
                options={[
                  { label: "Departure", value: "DEPARTURE" },
                  { label: "Arrival", value: "ARRIVAL" },
                ]}
                onChange={(val) => setNewFlight({ ...newFlight, type: val })}
              />
              <Input
                placeholder="Time"
                value={newFlight.time}
                onChange={(e) => setNewFlight({ ...newFlight, time: e.target.value })}
              />
              <Input
                placeholder="Date"
                value={newFlight.date}
                onChange={(e) => setNewFlight({ ...newFlight, date: e.target.value })}
              />
              <Input
                placeholder="Airline"
                value={newFlight.airline}
                onChange={(e) => setNewFlight({ ...newFlight, airline: e.target.value })}
              />
              <Input
                placeholder="City"
                value={newFlight.city}
                onChange={(e) => setNewFlight({ ...newFlight, city: e.target.value })}
              />
              <Input
                placeholder="Airport"
                value={newFlight.airport}
                onChange={(e) => setNewFlight({ ...newFlight, airport: e.target.value })}
              />
              <Button type="dashed" icon={<PlusOutlined />} onClick={addFlight}>
                Add Flight
              </Button>
            </Space>
          </div>
        </Form.Item>

        {/* Background Upload + Remove Slide */}
        <Form.Item style={{ marginBottom: 0 }} label="Background & Remove">
            <Flex vertical gap={15}>
            <Upload
              accept="image/*"
              beforeUpload={() => false}
              showUploadList={false}
              onChange={handleBgUpload}
            >
              <Button type="primary" icon={<UploadOutlined />}>
                Upload Background
              </Button>
            </Upload>
             {formData.bg && (
              <img
                src={formData.bg}
                alt="Background Preview"
                className="block mt-2 w-full h-32 max-w-xs max-h-xs object-cover rounded-lg border"
              />
            )}
            <Button type="primary" danger onClick={() => removeSlide(slide.id)}>
              <DeleteOutlined /> Remove Slide
            </Button>
          </Flex>
        </Form.Item>
      </Form>
    </div>
  );
};

export default FlightDetailsEditor;
